import { GetSubscriptions } from './apis';

export function getHasActiveSubscriptionFromQueryResponse(subscription: GetSubscriptions.Response) {
  return subscription?.status === 'active';
}

export function getHasSubscriptionFromQueryResponse(subscription: GetSubscriptions.Response) {
  return subscription !== null;
}
